module.exports = __webpack_public_path__ + "img/07d8bbe3c28b888e36468b09bde2f339.png";